export default function (props: any) {
    return (
        <svg width="44" height="44" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g fill="none" fillRule="evenodd">
                <circle fillOpacity=".421" fill="#FFF" cx="22" cy="22" r="17" />
                <path d="m18.266 15.236 9.798 6.3a.7.7 0 0 1 0 1.177l-9.798 6.299a.7.7 0 0 1-1.078-.59V15.826a.7.7 0 0 1 1.078-.589z" fill="#222" />
            </g>
        </svg>
    );
}
